import { useEffect } from 'react';
import Card from '~/components/Card';
import { addBreadcrumb } from '~/utils/observability';
import { useRouteError } from '~/utils/routing';
import { NoReturnMethodsError } from './returnMethods';

export default function ReturnMethodsErrorBoundary() {
  const error = useRouteError();

  // If the error is not a NoReturnMethodsError, we throw it to be handled by the global error handler
  if (!(error instanceof NoReturnMethodsError)) {
    throw error;
  }

  useEffect(() => {
    addBreadcrumb({ message: error.message, level: 'warning' });
  }, [error]);

  return (
    <Card headline="Sorry about that..." className="mt-8">
      <p>
        It looks like this return can&apos;t be handled automatically, please
        reach out to our team for help.
      </p>
    </Card>
  );
}
